// src/pages/LegalNotice.jsx
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/footer";

/* ---- Brand ---- */
const BRAND = "#4CB1A1";
const BRAND_HOVER = "#2B8D80";

/* ---- ICONS (Bootstrap-like) ---- */
const Icons = {
  info: (cls="") => (
    <svg className={cls} viewBox="0 0 16 16" fill="currentColor">
      <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.03.533.305.533.194 0 .486-.07.685-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.739-3.468c.063-.293.005-.399-.288-.47l-.45-.081.081-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
    </svg>
  ),
  id: (cls="") => (
    <svg className={cls} viewBox="0 0 16 16" fill="currentColor">
      <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm4.5 0a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6m5 2.755C12.146 12.825 10.623 12 8 12s-4.146.826-5 1.755V14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1z"/>
    </svg>
  ),
  target: (cls="") => (
    <svg className={cls} viewBox="0 0 16 16" fill="currentColor">
      <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m0-2A6 6 0 1 1 8 2a6 6 0 0 1 0 12"/>
      <circle cx="8" cy="8" r="3"/>
    </svg>
  ),
  shield: (cls="") => (
    <svg className={cls} viewBox="0 0 16 16" fill="currentColor">
      <path d="M5.072 1.106 8 .051l2.928 1.055A2 2 0 0 1 12 3.02V6.5c0 2.99-1.507 5.224-3.885 6.82a1.9 1.9 0 0 1-2.23 0C3.507 11.724 2 9.49 2 6.5V3.02a2 2 0 0 1 3.072-1.914"/>
    </svg>
  ),
  link: (cls="") => (
    <svg className={cls} viewBox="0 0 16 16" fill="currentColor">
      <path d="M6.354 5.5H4a3 3 0 1 0 0 6h2.354a.5.5 0 0 0 0-1H4a2 2 0 1 1 0-4h2.354a.5.5 0 0 0 0-1z"/>
      <path d="M10 4.5h2a3 3 0 1 1 0 6h-2a.5.5 0 1 1 0-1h2a2 2 0 1 0 0-4h-2a.5.5 0 1 1 0-1z"/>
      <path d="M5.5 8a.5.5 0 0 1 .5-.5h4.5a.5.5 0 1 1 0 1H6a.5.5 0 0 1-.5-.5z"/>
    </svg>
  ),
  fileText: (cls="") => (
    <svg className={cls} viewBox="0 0 16 16" fill="currentColor">
      <path d="M4 0h5l3 3v13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/><path fill="#fff" d="M9 3V0l3 3z"/><path fill="#fff" d="M5 6h6v1H5zm0 2h6v1H5zm0 2h4v1H5z"/>
    </svg>
  ),
  warn: (cls="") => (
    <svg className={cls} viewBox="0 0 16 16" fill="currentColor">
      <path d="M7.938 2.016a1.13 1.13 0 0 1 2.124 0l5.796 11.99c.39.806-.183 1.744-1.062 1.744H3.204c-.88 0-1.452-.938-1.062-1.744zM8 12a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-.5-6.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-1 0z"/>
    </svg>
  ),
  gavel: (cls="") => (
    <svg className={cls} viewBox="0 0 16 16" fill="currentColor">
      <path d="M2 13h12v2H2z"/><path d="M8.972 1.146a1 1 0 0 1 1.414 0l1.768 1.768a1 1 0 0 1 0 1.414L9.268 7.214 6.818 4.764zM5.404 6.178 2.6 8.982l1.414 1.414 2.804-2.804zM9.975 7.922l2.121 2.121-1.414 1.414-2.12-2.12z"/>
    </svg>
  ),
  mail: (cls="") => (
    <svg className={cls} viewBox="0 0 16 16" fill="currentColor">
      <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2L8 9 0 4z"/>
      <path d="M0 4l8 5 8-5v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"/>
    </svg>
  ),

    personal: (cls="") => (
   <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-person-fill" viewBox="0 0 16 16">
  <path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2m-1 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-3 4c2.623 0 4.146.826 5 1.755V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1.245C3.854 11.825 5.377 11 8 11"/>
</svg>
  ),

     terms: (cls="") => (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-book-half" viewBox="0 0 16 16">
  <path d="M8.5 2.687c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783"/>
</svg>
  ),

    cookie: (cls="") => (
    <svg className={cls} viewBox="0 0 16 16" fill="currentColor">
      <path d="M8 0a8 8 0 1 0 8 8c0-.55-.045-1.086-.132-1.607A2 2 0 0 1 13.5 4.5a2 2 0 0 1-2-2A2 2 0 0 1 9 .132 8.1 8.1 0 0 0 8 0M5.5 6A1.5 1.5 0 1 1 7 7.5 1.5 1.5 0 0 1 5.5 6m5 1a1 1 0 1 1-1 1 1 1 0 0 1 1-1M6 10a1 1 0 1 1-1 1 1 1 0 0 1 1-1"/>
    </svg>
  ),


    copy: (cls="") => (
 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-c-circle-fill" viewBox="0 0 16 16">
  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.146 4.992c.961 0 1.641.633 1.729 1.512h1.295v-.088c-.094-1.518-1.348-2.572-3.03-2.572-2.068 0-3.269 1.377-3.269 3.638v1.073c0 2.267 1.178 3.603 3.27 3.603 1.675 0 2.93-1.02 3.029-2.467v-.093H9.875c-.088.832-.75 1.418-1.729 1.418-1.224 0-1.927-.891-1.927-2.461v-1.06c0-1.583.715-2.503 1.927-2.503"/>
</svg>
  ),

    delete: (cls="") => (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"/>
</svg>
  ),

    jurisdiction: (cls="") => (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard-fill" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M10 1.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-5 0A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5v1A1.5 1.5 0 0 1 9.5 4h-3A1.5 1.5 0 0 1 5 2.5zm-2 0h1v1A2.5 2.5 0 0 0 6.5 5h3A2.5 2.5 0 0 0 12 2.5v-1h1a2 2 0 0 1 2 2V14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2"/>
</svg>
  ),


};

/* ---- SECTIONS ---- */
const SECTIONS = [
  { id: "overview", title: "Legal Notice", icon: "info" },
  { id: "id-owner", title: "Identification and Ownership", icon: "id" },
  { id: "purpose", title: "Purpose", icon: "target" },
  { id: "terms", title: "Terms & Conditions of Use", icon: "terms" },
  { id: "security", title: "Security measures", icon: "shield" },
  { id: "personal-data", title: "Personal data we collect", icon: "personal" },
  { id: "contents", title: "Contents", icon: "fileText" },
  { id: "cookies", title: "Cookies policy", icon: "cookie" },
  { id: "links", title: "Links to other websites", icon: "link" },
  { id: "ip", title: "Intellectual & industrial property", icon: "copy" },
  { id: "liability", title: "Limitation of liability", icon: "warn" },
  { id: "exclusion", title: "Right of exclusion", icon: "delete" },
  { id: "jurisdiction", title: "Jurisdiction", icon: "jurisdiction" },
  { id: "contact", title: "Contact", icon: "mail" },
];

export default function LegalWarning() {
  const tocRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const links = Array.from(tocRef.current?.querySelectorAll("a[data-id]") || []);
    const ids = links.map(a => a.getAttribute("data-id"));
    const sections = ids.map(id => document.getElementById(id)).filter(Boolean);

    const io = new IntersectionObserver(
      (entries) => {
        const vis = entries.filter(e => e.isIntersecting)
          .sort((a,b)=> b.intersectionRatio - a.intersectionRatio)[0]?.target.id;
        if (vis) {
          links.forEach(a =>
            a.setAttribute("aria-current", a.getAttribute("data-id") === vis ? "true" : "false")
          );
        }
      },
      { rootMargin: "-30% 0px -60% 0px", threshold: [0,0.15,0.3,0.6,1] }
    );
    sections.forEach(s => io.observe(s));

    const onScroll = () => {
      const scrolled = window.scrollY + window.innerHeight;
      const max = document.documentElement.scrollHeight;
      if (scrolled >= max - 2) {
        const lastId = ids[ids.length - 1];
        links.forEach(a => a.setAttribute("aria-current", a.getAttribute("data-id") === lastId ? "true":"false"));
      }
      if (window.scrollY <= 1) {
        const firstId = ids[0];
        links.forEach(a => a.setAttribute("aria-current", a.getAttribute("data-id") === firstId ? "true":"false"));
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });

    const onClick = (e) => {
      const id = e.currentTarget.getAttribute("data-id");
      const target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      target.classList.add("ring-4","ring-[color:rgba(13,148,136,0.25)]","transition-shadow","duration-700");
      setTimeout(()=> target.classList.remove("ring-4","ring-[color:rgba(13,148,136,0.25)]"), 800);
    };
    links.forEach(a => a.addEventListener("click", onClick));

    return () => {
      io.disconnect();
      window.removeEventListener("scroll", onScroll);
      links.forEach(a => a.removeEventListener("click", onClick));
    };
  }, []);

  const iconMenuCls = "w-4 h-4 flex-none text-slate-600";
  const iconCardCls = "w-5 h-5";
  const brandLinkCls = `underline underline-offset-2 decoration-transparent hover:decoration-current transition-colors text-[${BRAND}] hover:text-[${BRAND_HOVER}]`;

  const Card = ({ id, title, icon, children }) => (
    <section id={id} className="bg-white border border-slate-200 rounded-xl shadow-sm p-5 sm:p-6 mb-5 scroll-mt-28">
      <h2 className="flex items-center gap-3 text-slate-900 font-semibold text-lg">
        <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-teal-50 text-teal-600">
          {Icons[icon](iconCardCls)}
        </span>
        {title}
      </h2>
      <div className="mt-3 text-slate-700 leading-relaxed">{children}</div>
    </section>
  );

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Back arrow */}
      <button
        type="button"
        onClick={() => window.history.length > 1 ? navigate(-1) : navigate("/")}
        className="fixed left-5 top-6 z-50 flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white/60 backdrop-blur transition hover:border-[#38c8ba]/40 hover:text-[#38c8ba] sm:left-8 sm:top-8"
        aria-label="Voltar"
      >
        <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M17 10a.75.75 0 01-.75.75H5.612l4.158 3.96a.75.75 0 11-1.04 1.08l-5.5-5.25a.75.75 0 010-1.08l5.5-5.25a.75.75 0 111.04 1.08L5.612 9.25H16.25A.75.75 0 0117 10z" clipRule="evenodd" />
        </svg>
      </button>

      {/* Header */}
      <header className="border-b bg-slate-50">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
          <h1 className="mt-2 text-3xl sm:text-4xl font-extrabold text-slate-900">Legal Notice</h1>
          <div className="mt-2 h-0.5 w-16 rounded-full" style={{ backgroundColor: BRAND }} />
          <p className="mt-2 text-slate-500">Identification, terms of use and legal information.</p>
        </div>
      </header>

      {/* Body */}
      <main className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <div className="grid grid-cols-1 md:grid-cols-[280px_1fr] gap-4 sm:gap-6">
          {/* Sidebar */}
          <aside className="md:sticky md:top-24 self-start">
            <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-3">
              <p className="px-2 pb-2 text-[13px] font-medium text-slate-500">Quick Navigation</p>
              <nav ref={tocRef}>
                <ul className="space-y-1">
                  {SECTIONS.map(({ id, title, icon }) => (
                    <li key={id}>
                      <a
                        data-id={id}
                        href={`#${id}`}
                        aria-current="false"
                        className="
                          group relative flex items-center gap-3 rounded-lg px-3 py-2
                          text-[14px] text-slate-700 hover:bg-teal-50
                          aria-current:bg-teal-50
                        "
                      >
                        {Icons[icon](iconMenuCls)}
                        <span className="flex-1">{title}</span>
                        <span
                          className="
                            pointer-events-none absolute left-0 top-1 bottom-1 w-0.5 rounded
                            bg-teal-500 opacity-0 transition-opacity duration-200
                            group-hover:opacity-100 group-aria-current:opacity-100
                          "
                        />
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          </aside>

          {/* Content */}
          <div>
            <Card {...SECTIONS[0]}>
              <p>Home / Legal Notice</p>
            </Card>

            <Card {...SECTIONS[1]}>
              <p><strong>Holder:</strong> Invisible Cloud Lda.<br/>
              <strong>NIF/CIF:</strong> PT513796487<br/>
              <strong>Address:</strong> R. Alfredo Allen 455/461, 4200-135 Porto, Portugal<br/>
              <strong>E-mail:</strong> <a className={brandLinkCls} href="mailto:info@invisiblecloud.pt">info@invisiblecloud.pt</a></p>
            </Card>

            <Card {...SECTIONS[2]}>
              <p>The purpose of <a className={brandLinkCls} href="https://invisiblecloud.pt">https://invisiblecloud.pt</a> is to inform about Invisible Cloud’s digital collections SaaS.</p>
            </Card>

            <Card {...SECTIONS[3]}>
              <p>The use of the site grants the status of User and implies full acceptance of the Legal Notice and the <a className={brandLinkCls} href="/politica-privacidade">Privacy Policy</a> and <a className={brandLinkCls} href="/politica-cookies">Cookies Policy</a>. If you do not agree, please refrain from using the site.</p>
              <p className="mt-3">Accessing the site does not imply the start of a commercial relationship. You agree not to use contents for unlawful purposes or in ways that may damage, disable, overload or deteriorate the site or third-party systems.</p>
            </Card>

            <Card {...SECTIONS[4]}>
              <p>Personal data may be stored in databases owned by Invisible Cloud Lda., which adopts technical, organizational and security measures to ensure confidentiality, integrity and quality of information, in accordance with applicable law.</p>
              <p className="mt-3">However, Internet systems are not entirely reliable; Invisible Cloud Lda. cannot guarantee the absence of viruses or other harmful elements despite the adopted safeguards.</p>
            </Card>

            <Card {...SECTIONS[5]}>
              <p>You can consult all information regarding personal data we collect on the <a className={brandLinkCls} href="/politica-privacidade">Privacy Policy</a> page.</p>
            </Card>

            <Card {...SECTIONS[6]}>
              <p>Information is obtained from sources considered reliable, but Invisible Cloud Lda. does not guarantee it is exact, complete or up to date and declines responsibility for errors or omissions. Transmitting illegal content, malware, or messages that affect rights of Invisible Cloud Lda. or third parties is prohibited.</p>
              <p className="mt-3">Contents are informative and are not an offer or recommendation unless expressly indicated. We may modify, suspend, cancel, or restrict contents or links without prior notice.</p>
            </Card>

            <Card {...SECTIONS[7]}>
              <p>You can consult our privacy and cookies policy <a className={brandLinkCls} href="/politica-cookies">here</a>.</p>
            </Card>

            <Card {...SECTIONS[8]}>
              <p>Links to third-party sites are provided solely to inform about other information sources. They do not imply suggestion or recommendation. We are not responsible for the content of linked sites nor results obtained by following the links.</p>
              <p className="mt-3">Establishing a link does not imply any relationship or approval. On accessing an external site, read its privacy policy.</p>
            </Card>

            <Card {...SECTIONS[9]}>
              <p>All rights reserved. Reproduction, permanent storage, public dissemination or any commercial use of contents is expressly prohibited without prior written consent of Invisible Cloud Lda.</p>
            </Card>

            <Card {...SECTIONS[10]}>
              <p>Information and services may include inaccuracies or typographical errors; changes may be made at any time. We are not responsible for interruptions, network failures, loss of business, power outages, or other indirect damages beyond our control.</p>
              <p className="mt-3">We do not guarantee that services or contents are uninterrupted or error-free, or that servers are free of harmful components, though we strive to avoid incidents. Verify information with other sources before acting on it.</p>
            </Card>

            <Card {...SECTIONS[11]}>
              <p>Invisible Cloud Lda. may deny or withdraw access to the website and services, without prior notice, to users who fail to comply with this Legal Notice.</p>
            </Card>

            <Card {...SECTIONS[12]}>
              <p>This Legal Notice is governed by Portuguese law. Unless otherwise required, parties submit to the Courts of Porto, expressly waiving any other jurisdiction.</p>
            </Card>

            <Card {...SECTIONS[13]}>
              <p>Questions about these conditions or comments about <a className={brandLinkCls} href="https://invisiblecloud.pt">https://invisiblecloud.pt</a>? Email us at <a className={brandLinkCls} href="mailto:info@invisiblecloud.pt">info@invisiblecloud.pt</a> or call +351 221 450 660 (Chamada para a rede fixa nacional).</p>
              <p className="mt-3">Address: R. Alfredo Allen 455/461, 4200-135 Porto, Portugal.</p>
              <div className="mt-4 text-sm text-slate-500"> <a className={brandLinkCls} href="/politica-privacidade">Política de Privacidade</a> · <a className={brandLinkCls} href="/politica-cookies">Política de Cookies</a></div>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
